import React, { LegacyRef, useState, useCallback } from 'react';
import { ThemeProvider } from 'fronton-react';
import { CubeIcon } from '@fronton/icons-react';
import { ButtonWithGAClickButton } from '../../button';
import { MobileFixedPanelModal, MobileFixedPanelStructure } from '../../design-registration-panel';
import { Typography } from '../../typography';
import {
  signSectionPanel,
  signSectionPanelButtons,
  signSectionPanelMobileButton,
  signSectionPanelText,
  signSectionPanelTextWrapper,
  signSectionPanelWrapper,
} from './sign-section-panel-styles';

type SignSectionPanelProps = {
  elementBlock: string;
  elementName: string;
  mobilePanelStructure: MobileFixedPanelStructure;
  panelButton: React.ReactNode;
  panelRef: LegacyRef<HTMLDivElement>;
  text: string;
};

export const SIGN_SECTION_MOBILE_PANEL_STRUCTURE: MobileFixedPanelStructure = {
  content: {
    icon: CubeIcon,
    iconColor: 'accent-primary',
    iconType: 'duotone',
    text: '',
  },
  mobileButton: {
    openModal: true,
    label: 'Записаться на проектирование',
  },
  actionBlock: [],
};

export const SignSectionPanel: React.FC<SignSectionPanelProps> = ({
  elementBlock,
  elementName,
  mobilePanelStructure,
  panelButton,
  panelRef,
  text,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <ThemeProvider>
      <div ref={panelRef} className={signSectionPanelWrapper}>
        <div className={signSectionPanel}>
          <div className={signSectionPanelTextWrapper}>
            <CubeIcon
              size="40px"
              color="var(--accent-primary)"
              type="duotone"
              strokeWidth={0.5}
            />
            <Typography
              className={signSectionPanelText}
              variant="s"
              size="body_short"
              color="text-invert">
              {text}
            </Typography>
          </div>
          <div className={signSectionPanelButtons}>
            {panelButton}
          </div>
        </div>

        <ButtonWithGAClickButton
          className={signSectionPanelMobileButton}
          elementBlock={elementBlock}
          elementName={elementName}
          elementText="Записаться на проектирование"
          variant="accent"
          adaptive={false}
          wide
          onClick={handleOpenModal}>
          Записаться на&nbsp;проектирование
        </ButtonWithGAClickButton>

        <MobileFixedPanelModal
          elementName={elementName}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          structure={mobilePanelStructure}
        />
      </div>
    </ThemeProvider>
  );
};
